"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAuthCookieDomain = exports.deleteAuthToken = exports.setAuthToken = exports.getAuthToken = void 0;
const tracking_1 = require("../tracking");
const _1 = require(".");
function getAuthToken(params) {
    const { req, res } = params;
    return (0, _1.getCookie)({ req, res, key: tracking_1.AUTH_TOKEN_KEY });
}
exports.getAuthToken = getAuthToken;
function setAuthToken(params) {
    const { req, res, token } = params;
    (0, _1.setCookie)({
        ...getAuthTokenCookieSettings({ req, res }),
        value: token,
        daysBeforeExpiration: tracking_1.AUTH_TOKEN_EXPIRATION_DAYS,
    });
}
exports.setAuthToken = setAuthToken;
function deleteAuthToken(params) {
    const { req, res } = params;
    (0, _1.setCookie)({
        ...getAuthTokenCookieSettings({ req, res }),
        value: '',
        expires: new Date(0),
    });
}
exports.deleteAuthToken = deleteAuthToken;
function getAuthTokenCookieSettings(params) {
    const { req, res } = params;
    return {
        res,
        key: tracking_1.AUTH_TOKEN_KEY,
        domain: getAuthCookieDomain({ req }),
    };
}
function getAuthCookieDomain(params) {
    return (0, _1.getTopLevelCookieDomain)(params);
}
exports.getAuthCookieDomain = getAuthCookieDomain;
//# sourceMappingURL=auth.js.map